import React, { useEffect, useState } from 'react'
import './index.less'
import { Space } from 'antd'
import { getPortImg } from '@/api/modules/community'

type PortItemProps = {
    id?: string
    value?: string
    onChange?: (value: string) => void
}

let exitPortImg: any = null

const PortItem: React.FC<PortItemProps> = (props) => {

    const { id, value, onChange } = props

    const [portImg, setPortImg] = useState<any>([])    // 选择的图片列表

    useEffect(() => {
        if (exitPortImg) {
            setPortImg(exitPortImg)
        } else {
            fetchPortImageList()
        }
    }, [])

    const fetchPortImageList = async () => {
        const res = await getPortImg().catch(() => { })
        setPortImg(exitPortImg = (res?.course ?? []))
    }

    return <Space size={10} id={id}>
        {
            portImg.map((item: any) => {
                return <div className='ExperPorts-porticon' data-select={value === item?.image} key={item?.pictureId} onClick={() => {
                    onChange?.(item?.image)
                }}>
                    <img src={item?.image} alt="" />
                </div>
            })
        }
    </Space>
}

export default PortItem